import { Menu, MenuButton, MenuList, MenuItem, Icon, useMediaQuery, Image, Link as NativeLink } from '@chakra-ui/react';
import React, { useMemo, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

import { IconLogout } from 'assets/icons';
import FallbackAvatar from 'components/FallbackAvatar';
import { useLogout } from 'hooks/auth/useLogout';
import { useUserStore } from 'store/useUserStore';
import { allowedRoute } from 'utils/allowedRoutes';

import AvatarMenuData from './AvatarMenuData';

const AvatarMenu: React.FC<unknown> = () => {
  const { t } = useTranslation(['common']);
  const [allowedMenuData, setAllowedMenuData] = useState<any>(AvatarMenuData);

  const [isLargerThan768, isLargerthan1280] = useMediaQuery(['(min-width: 768px)', '(min-width: 1280px)'], {
    ssr: false,
  });

  const user: any = useUserStore(state => state.user);

  const iconProps = useMemo(
    () => ({
      p: '2.5',
      bg: 'primary.50',
      height: '36px',
      width: '36px',
      mr: '1',
      borderRadius: '4px',
      sx: { '& path': { fill: 'gray.500' } },
    }),
    []
  );

  useEffect(() => {
    const newMenuData = allowedMenuData.filter(({ access }: any) => {
      return allowedRoute(access);
    });

    setAllowedMenuData(newMenuData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleLogout = useLogout();

  return (
    <Menu isLazy closeOnBlur autoSelect={false}>
      <MenuButton mr={6}>
        <Image
          src={user?.userInfo?.employee_image}
          fallback={
            <FallbackAvatar
              borderRadius="50%"
              name={user?.userInfo?.firstName + ' ' + user?.userInfo?.lastName}
              boxSize={isLargerThan768 ? '48px' : '40px'}
            />
          }
          alt={user?.userInfo?.firstName + ' ' + user?.userInfo?.lastName}
          boxSize={isLargerThan768 ? '48px' : '40px'}
          objectFit="cover"
          borderRadius="50%"
        />
      </MenuButton>
      <MenuList minWidth="0">
        {allowedMenuData.map(({ icon, label, path, belowScreenSize1280, nativeLink, newTab }: any) => {
          if (isLargerthan1280 && belowScreenSize1280) return null;

          return (
            <MenuItem
              key={path}
              as={nativeLink ? NativeLink : RouterLink}
              // @ts-ignore
              to={path}
              href={path}
              target={newTab ? '_blank' : undefined}
              _focus={{ bg: 'primary.100', boxShadow: 'none' }}
              _hover={{ bg: 'primary.100', textDecoration: 'none' }}
              icon={<Icon as={icon} {...iconProps} />}
            >
              {t(label)}
            </MenuItem>
          );
        })}

        <MenuItem
          _hover={{ bg: 'primary.100' }}
          fontWeight="semibold"
          icon={
            <Icon
              as={IconLogout}
              {...iconProps}
              bg="rgba(255, 126, 126, 0.2)"
              sx={{ '& path': { fill: 'secondary.700' } }}
            />
          }
          color="secondary.700"
          onClick={handleLogout}
        >
          {t('common:logout')}
        </MenuItem>
      </MenuList>
    </Menu>
  );
};

export default AvatarMenu;
